import React from 'react'
import PropTypes from 'prop-types'
// import { Image } from 'antd-mobile'
import foodImage from '../../assets/images/def_img_food.png'
import { replaceCDNDomain } from '../../utils'
// import service from '../../config/services';
// const { domain } = service;

const AutoImage = ({
    src = '',
    alt = '',
    size = 'b',
    style = {},
    className = '',
    onError ,
    onLoad = () => { },
    storeInfo = {}
}) => {
    let defaultImage = foodImage
    if (storeInfo && storeInfo.productImages) {
        // console.log(storeInfo, '/////storeInfo/////')
        defaultImage = storeInfo.productImages
    }
    //size : b,m,s
    const sizeMap = {
        b: '_b',
        m: '_m',
        s: '_s'
    }

    const getImageUrl = (src, size) => {
        if (!src) return defaultImage;
        //当src没有https 或http时，返回defaultImage
        if (!src.includes('https') && !src.includes('http')) {
            return defaultImage
        }

        if (size === 'original') return src

        try {
            // 获取最后一个斜杠的位置
            const lastSlashIndex = src.lastIndexOf('/');
            // 获取最后一个点的位置
            const lastDotIndex = src.lastIndexOf('.');

            if (lastSlashIndex === -1 || lastDotIndex === -1) return src;

            // 获取路径部分和文件名部分
            let path = src.substring(0, lastSlashIndex + 1);

            // 匹配路径
            if (/^https?:\/\/file\.jimutour\.com/.test(path)) {
                // path = path.replace(/^https?:\/\/file\.jimutour\.com/, domain.fileCDN) ;
                path = replaceCDNDomain(path)
            }

            const fileName = src.substring(lastSlashIndex + 1, lastDotIndex);
            const extension = src.substring(lastDotIndex);

            return `${path}${fileName}${sizeMap[size]}${extension}`;
        } catch (error) {
            console.error('Error processing image URL:', error);
            return src;
        }
    };

    const handleError = (e) => {
        // e.target.src = defaultImage
        if (onError) {
            onError(e)
            return
        }

        // 如果图片加载失败，尝试使用原始URL
        if (e.target.src !== defaultImage) {
            e.target.src = defaultImage
        }
    }

    const imgUrl = getImageUrl(src, size)
    // console.log(imgUrl,'/////imgUrl/////')
    return (
        <img
            // fallback={<img src={defaultImage} alt={alt}  className={className} />}
            src={imgUrl}
            alt={alt}
            style={style}
            className={className}
            onError={handleError}
            // lazy
            onLoad={onLoad}
        />
    )
}

AutoImage.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    size: PropTypes.oneOf(['b', 'm', 's', 'original']),
    style: PropTypes.object,
    className: PropTypes.string,
    onError: PropTypes.func,
    onLoad: PropTypes.func
}

export default React.memo(AutoImage)
